"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateBlackoutDateRequestToJSON = exports.CreateBlackoutDateRequestFromJSONTyped = exports.CreateBlackoutDateRequestFromJSON = exports.instanceOfCreateBlackoutDateRequest = void 0;
var CampaignAdProduct_1 = require("./CampaignAdProduct");
/**
 * Check if a given object implements the CreateBlackoutDateRequest interface.
 */
function instanceOfCreateBlackoutDateRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "startDate" in value;
    isInstance = isInstance && "endDate" in value;
    isInstance = isInstance && "country" in value;
    isInstance = isInstance && "adProduct" in value;
    return isInstance;
}
exports.instanceOfCreateBlackoutDateRequest = instanceOfCreateBlackoutDateRequest;
function CreateBlackoutDateRequestFromJSON(json) {
    return CreateBlackoutDateRequestFromJSONTyped(json, false);
}
exports.CreateBlackoutDateRequestFromJSON = CreateBlackoutDateRequestFromJSON;
function CreateBlackoutDateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'startDate': (new Date(json['start_date'])),
        'endDate': (new Date(json['end_date'])),
        'country': json['country'],
        'adProduct': (0, CampaignAdProduct_1.CampaignAdProductFromJSON)(json['ad_product']),
    };
}
exports.CreateBlackoutDateRequestFromJSONTyped = CreateBlackoutDateRequestFromJSONTyped;
function CreateBlackoutDateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'start_date': (value.startDate.toISOString()),
        'end_date': (value.endDate.toISOString()),
        'country': value.country,
        'ad_product': (0, CampaignAdProduct_1.CampaignAdProductToJSON)(value.adProduct),
    };
}
exports.CreateBlackoutDateRequestToJSON = CreateBlackoutDateRequestToJSON;
